<template>
  <hic-dialog append-to-body :close-on-click-modal="false" :visible="visible" width="90%" top="10vh" :title="title" @close="close" @open="open">
    <el-row type="flex" align="middle" style="text-align: left">
      <el-col>
        <el-input class="condition-wide left-pad" v-model="condition.keyword" placeholder="姓名、床位号" size="small" v-on:keyup.enter.native="queryEntitie" clearable @clear="queryEntitie">
          <el-button type="info" :loading="meta.loading" slot="append" icon="el-icon-search" @click="queryEntitie"> </el-button>
        </el-input>
      </el-col>
    </el-row>
    <el-container class="f-h mt10" ref="">
      <el-aside class="fee" width="300px" style="border-right: 1px solid #ccc; height: 600px;">
        <el-table ref="singleTable" highlight-current-row  @current-change="selectPatient" :data="entities.items" v-loading="meta.loading">
          <!-- <el-table-column align="center" width="50" label="">
            <template slot-scope="{ row }">
              <el-checkbox v-model="row.checked" @change="(val) => selectPatient(row)"></el-checkbox>
            </template>
          </el-table-column> -->
          <el-table-column align="center" label="床位号" prop="bedNo" width="80px"></el-table-column>
          <el-table-column align="center" label="姓名" prop="patientName"></el-table-column>
        </el-table>
      </el-aside>
      <el-container style="">
        <el-row style="width: 100%">
          <el-col style="height: 80%; position: relative">
            <feeEnter v-if="title == '费用录入'" ref="refEnter" :infoDetail="selector" @update="$emit('close')" @close="$emit('update:visible', false)"></feeEnter>
            <feeRefund v-else ref="refRefund" :infoDetail="selector" @update="$emit('close')" @close="$emit('update:visible', false)"></feeRefund>
          </el-col>
        </el-row>
      </el-container>
    </el-container>
    <!-- <template slot="footer">&nbsp;&nbsp;</template> -->
  </hic-dialog>
</template>
<script>
  import { mapGetters } from "sw-hic";
  import api from "./api";
  // import adviceTable from './_table2.vue';
  export default {
    components: {
      feeEnter: () => import("./feeEnter.vue"),
      feeRefund: () => import("./feeRefund.vue"),
    },
    props: {
      title: String,
      visible: Boolean,
      list: Array,
    },
    data() {
      return {
        meta: {
          loading: false,
        },
        entities: {},
        condition: {
          state: "已入住",
        },
        adviceEntitie: {},
        selectPatientList: [],
        selector: {},
      };
    },
    computed: {
      ...mapGetters(["user"]),
    },
    mounted() {},
    methods: {
      close() {
        this.$emit("update:visible", false);
      },
      open() {
        this.selectPatientList = [];
        this.queryEntitie();
      },
      queryEntitie() {
        let con = this.$utils.Obj.clone(this.condition);
        con.originalDeptCode = this.user.deptCode;

        this.meta.loading = true;
        api.Hospitalization.query(con)
          .then((res) => {
            this.entities = res;
            this.$refs.singleTable.setCurrentRow(res.items[0]);
            this.selectPatient(res.items[0]);

          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      selectPatient(item) {
        if (item) {
          this.entities.items.forEach((ele) => {
            this.$set(ele, "checked", ele.id == item.id);
          });
          this.$set(this, "selector", item);
          // if(this.title == '费用录入') this.$refs.refEnter.open()
          // else this.$refs.refRefund.open()
        } else {
          this.selectPatientList = [];
        }
      },
    },
  };
</script>
<style>
/* .el-table .current-row {
  background-color: #0cec0c !important;
} */
.fee .el-table__body tr.current-row>td.el-table__cell {
  background-color: #2890f1 !important;
  color: #fff !important;
}
</style>